// extracted by mini-css-extract-plugin
var _1 = "TwoColumnRow-module__animateUploadProgressBarWidth--E21gS";
var _2 = "TwoColumnRow-module__animatedBackground--ESgh8";
var _3 = "TwoColumnRow-module__aside--lz2qo";
var _4 = "TwoColumnRow-module__full--gA3O1";
var _5 = "TwoColumnRow-module__largerThanAsideShown--BKnqa";
var _6 = "TwoColumnRow-module__largerThanDesktop--FfFK_";
var _7 = "TwoColumnRow-module__largerThanTablet--ptTRo";
var _8 = "TwoColumnRow-module__main--UIEUw";
var _9 = "1100px";
var _a = "916px";
var _b = "655px";
var _c = "TwoColumnRow-module__row--aG3nU";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "aside", _4 as "full", _5 as "largerThanAsideShown", _6 as "largerThanDesktop", _7 as "largerThanTablet", _8 as "main", _9 as "minAsideShownWidth", _a as "minDesktopWidth", _b as "minTabletWidth", _c as "row" }
